var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1111 8C13.3873 8 13.6111 8.22386 13.6111 8.5V9.5H18.3889V8.5C18.3889 8.22386 18.6127 8 18.8889 8C19.165 8 19.3889 8.22386 19.3889 8.5V9.5H21.0556C22.1471 9.5 23 10.4134 23 11.5V22C23 23.0866 22.1471 24 21.0556 24H10.9444C9.85294 24 9 23.0866 9 22V11.5C9 10.4134 9.85294 9.5 10.9444 9.5H12.6111V8.5C12.6111 8.22386 12.835 8 13.1111 8ZM12.6111 10.5H10.9444C10.4405 10.5 10 10.9298 10 11.5V14H22V11.5C22 10.9298 21.5595 10.5 21.0556 10.5H19.3889V11.5C19.3889 11.7761 19.165 12 18.8889 12C18.6127 12 18.3889 11.7761 18.3889 11.5V10.5H13.6111V11.5C13.6111 11.7761 13.3873 12 13.1111 12C12.835 12 12.6111 11.7761 12.6111 11.5V10.5ZM22 15H10V22C10 22.5702 10.4405 23 10.9444 23H21.0556C21.5595 23 22 22.5702 22 22V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.5977b9146c5f675adcd7ccb29fc51229.svg";
export { ForwardRef as ReactComponent };